export default "__VITE_ASSET__85edb113__"